/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_largo_color.svg'
import {APARTADOS} from "../../Constantes";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {WhatsApp} from '@mui/icons-material'
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {useNavigate} from "react-router-dom";

const BarraPc = () => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    maxWidth: '1400px',
                    px: 3,
                    py: 3,
                    mb: -13.5,

                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <img
                                onClick={() => navigate('/Home')}
                                src={logo} width={250} height={'auto'} style={{cursor: 'pointer'}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start', px: 6}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{color: '#fff'}}
                            >

                                {APARTADOS.map((it, index) => {

                                    if (index >= 1) {

                                        return (
                                            <Typography
                                                onClick={() => scrolearAComponente(it)}
                                                sx={{
                                                    fontFamily: 'Roboto',
                                                    transition: "all .2s ease-in-out",
                                                    cursor: 'pointer',
                                                    borderBottom: 1,
                                                    borderColor: '#ffffff00',
                                                    '&:hover': {
                                                        borderColor: '#ffffff',
                                                    }
                                                }}
                                            >
                                                {it}
                                            </Typography>
                                        )
                                    }
                                })}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end'}}>
                            <Button
                                onClick={() => iniciarChatWass({mensaje: 'Hola Magaza'})}
                                endIcon={<WhatsApp/>} sx={{pt: 1, pb: 0.7}}>Contacto</Button>
                        </Grid>

                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc    